// eslint-disable-next-line import/prefer-default-export
export const fileteredProductGridItemLabels = (labels) => {
  if (!labels) {
    return {
      addToBag: '',
      readMore: '',
      readLess: '',
      shopCollection: '',
      shopthelook: '',
      youMayAlsoLike: '',
      recentlyViewed: '',
      interimSoldout: '',
      // shopnow: '',
      clickHere: '',
      pointsAndRewardsText: '',
      inGridDescription: '',
      inMultiGridHeader: '',
      inMultiGridDescription: '',
      plpSelectStore: '',
      pickupAt: '',
      plpChangeStore: '',
      plpSelectNearbyStore: '',
      pickupInStore: '',
      plpAvailableShiptoHome: '',
    };
  }

  const {
    PLP: {
      plpTiles: {
        lbl_add_to_bag: addToBag,
        lbl_plpTiles_shop_collection: shopCollection,
        lbl_plpTiles_shop_the_look: shopthelook,
        lbl_page_not_found: pageNotFound,
        lbl_you_may_also_like: youMayAlsoLike,
        lbl_recently_viewed: recentlyViewed,
        lbl_you_may_like: youMayLike,
        lbl_plp_in_grid_description: inGridDescription,
        lbl_plp_in_multi_grid_header: inMultiGridHeader,
        lbl_plp_in_multi_grid_description: inMultiGridDescription,
        lbl_plp_select_store: plpSelectStore,
        lbl_plp_select_at: pickupAt,
        lbl_plp_change_store: plpChangeStore,
        lbl_plp_select_nearby_store: plpSelectNearbyStore,
        lbl_plp_pickup_in_store: pickupInStore,
      },
      seoText: { lbl_read_more: readMore, lbl_read_less: readLess },
    },
    global: {
      CommonBrowseLabels: {
        lbl_category_clickHere: clickHere,
        lbl_best_seller: bestSellerBadgeLabel,
        lbl_plp_available_ship: plpAvailableShiptoHome,
        lbl_bopis_interimSoldoutMessage: interimSoldoutMessage,

        lbl_plp_carousel_default_title: plpGenericCarouselDefaultTitle,
        lbl_plp_shop_all: shopAllLabel,

        lbl_shop_similar: shopSimilar,
        lbl_hbm_department: hbmDepartment,
      },
      Sorting: {
        lbl_TCPBazaarVoiceRating: topRatedBadgeLabel,
        lbl_favoritedcount: mostFavoritedBadgeLabel,
      },
      generic: { lbl_tcp: tcpBrand, lbl_snj: snjBrand, lbl_pjp: pjpBrand },
    },
  } = labels;

  return {
    addToBag,
    readMore,
    readLess,
    shopCollection,
    shopthelook,
    pageNotFound,
    youMayAlsoLike,
    recentlyViewed,
    clickHere,
    youMayLike,
    topRatedBadgeLabel,
    bestSellerBadgeLabel,
    mostFavoritedBadgeLabel,
    snjBrand,
    tcpBrand,
    hbmDepartment,
    shopSimilar,
    shopAllLabel,
    plpGenericCarouselDefaultTitle,
    interimSoldoutMessage,
    plpAvailableShiptoHome,
    inGridDescription,
    inMultiGridHeader,
    inMultiGridDescription,
    plpSelectStore,
    plpChangeStore,
    pickupInStore,
    plpSelectNearbyStore,
    pickupAt,
    pjpBrand,
  };
};
